import { render, staticRenderFns } from "./crudConfigurations.vue?vue&type=template&id=33ab7620"
import script from "./crudConfigurations.vue?vue&type=script&lang=js"
export * from "./crudConfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports